import Vue from 'vue'

//vuex
import store from '../../stores'

//sleep 処理
window.sleep = msec => new Promise(resolve => setTimeout(resolve, msec));

//plugins
import WindowStatePlugin from '../../plugins/windowstate'

//components
import CreativeForm from '../../components/creative_form.vue'
import NewCreativeForm from '../../components/new_creative_form.vue' //新規ユーザーに対する別フロー用
import WidgetCreativeForm from '../../components/widget_creative_form.vue'
import CreativeEditForm from '../../components/creative_edit_form.vue'
import CreativePreview from '../../components/creative_preview.vue'
import PopUpPreview from '../../components/pop_up_preview.vue'
import OverlayImagePreview from '../../components/overlay_image_preview.vue'
import Report from '../../components/report.vue'
import NewReport from '../../components/new_report.vue'
import UserFlow from '../../components/analytics/user_flow.vue'
import Dashboard from '../../components/analytics/dashboard.vue'
import ScenarioPopupReport from '../../components/scenario_popup_report.vue'
import CalloutServiceLimit from '../../components/callouts/service_limit.vue'
import CalloutServiceHostLimit from '../../components/callouts/service_host_limit.vue'
import CalloutHostLimit from '../../components/callouts/host_limit.vue'
import ModalUserHost from '../../components/modals/user_host.vue'
import ModalWidgetCode from '../../components/modals/widget_code.vue'
import ModalWidgetCopy from '../../components/modals/widget_copy.vue'
import ModalPopUpCopy from '../../components/modals/pop_up_copy.vue'
import ModalAreaPopUpCopy from '../../components/modals/area_pop_up_copy.vue'
import ModalScenarioPopupCopy from '../../components/modals/scenario_popup_copy.vue'
import ModalWidgetCopyFree from '../../components/modals/widget_copy_free.vue'
import ModalReportCols from '../../components/modals/report_cols.vue'
import ModalPopUpCode from '../../components/modals/pop_up_code.vue'
import ModalUiElementCode from '../../components/modals/ui_element_code.vue'
import ModalHeatmapCode from '../../components/modals/heatmap_code.vue'
import ModalAreaPopUpCode from '../../components/modals/area_pop_up_code.vue'
import ModalOverlayImageCode from '../../components/modals/overlay_image_code.vue'
import ModalOverlayImageCopy from '../../components/modals/overlay_image_copy.vue'
import UrlList from '../../components/modals/url_list.vue'
import ModalPolicyAccept from '../../components/modals/policy_accept.vue'
import ModalUserInfoAdd from '../../components/modals/user_info_add.vue'
import NewModalUserInfoAdd from '../../components/modals/new_user_info_add.vue'
import ModalServiceNameChange from '../../components/modals/service_name_change.vue'
import PlanSelect from '../../components/plan_select.vue'
import PlanSelectNew from '../../components/plan_select_new.vue'
import Plans from '../../components/plans.vue'
import CreateCustomPlan from '../../components/create_custom_plan.vue'
import CurrentCustomPlans from '../../components/current_custom_plans.vue'
import AddCreditCardModal from '../../components/modals/add_credit_card.vue'
import PushCreditCardModal from '../../components/modals/push_credit_card.vue'
import ChangePlanModal from '../../components/modals/change_plan.vue'
import CancelPlanModal from '../../components/modals/cancel_plan.vue'
import ChangeCustomPlanModal from '../../components/modals/change_custom_plan.vue'
import ModalServiceLimit from '../../components/modals/service_limit.vue'
import GeneralModal from '../../components/modals/general.vue'
import InvoiceStatus from '../../components/invoice_status.vue'
import AlertInfoLoading from '../../components/parts/info_loading.vue'
import PrSetting from '../../components/pr_setting.vue'
import WidgetLayout from '../../components/widget_layout.vue'
import SetMainCreditCardButton from '../../components/buttons/set_main_credit_card.vue'
import InputToggleButton from '../../components/buttons/input-toggle_button.vue'
import RemoveCreditCardButton from '../../components/buttons/remove_credit_card.vue'
import TogglePreviewDevice from '../../components/buttons/toggle_preview_device.vue'
import WebToolsYoutubeUrl from '../../components/web_tools/youtube_url.vue'
import InitTags from '../../components/inits/tags.vue'
import ScrollHeatmap from '../../components/scroll_heatmap.vue'
import ClickHeatmap from '../../components/click_heatmap.vue'
import ResizeHeatmap from '../../components/resize_heatmap.vue'
import ResizeHeatmapBtn from '../../components/resize_heatmap_btn.vue'
import SynchronizedResizeHeatmap from '../../components/synchronized_resize_heatmap.vue'
import AttentionHeatmap from '../../components/attention_heatmap.vue'
import HeatmapMenu from '../../components/heatmap_menu.vue'
import HeatmapMenuNew from '../../components/heatmap_menu_new.vue'
import HeatmapSummary from '../../components/heatmap_summary.vue'
import HeatmapIframe from '../../components/heatmap_iframe.vue'
import HeatmapHeader from '../../components/heatmap_header.vue'
import PopupForm from '../../components/popup_form.vue'
import EditPopupForm from '../../components/edit_popup_form.vue'
import PopupToggleBtn from '../../components/buttons/popup_toggle_btn.vue'
import CreativeToggleBtn from '../../components/buttons/creative_toggle_btn.vue'
import TagDomainToggleBtn from '../../components/buttons/tag_domain_toggle_btn.vue'
import TagDomainPinBtn from '../../components/buttons/tag_domain_pin_btn.vue'
import CvTagForm from '../../components/cv_tag_form.vue'
import HeatmapForm from '../../components/heatmap_form.vue'
import HeatmapDate from '../../components/heatmap_date.vue'
import HeatmapEvent from '../../components/heatmap_event.vue'
import HeatmapOsPc from '../../components/heatmap_os_pc.vue'
import HeatmapOsSp from '../../components/heatmap_os_sp.vue'
import CurrentUser from '../../components/current_user.vue'
import HeatmapHtmlName from '../../components/heatmap_html_name.vue'
import HeatmapDesignNameNew from '../../components/heatmap_design_name_new.vue'
import CheckDomainTag from '../../components/check_domain_tag.vue'
import HeatmapToggleBtn from '../../components/buttons/heatmap_toggle_btn.vue'
import HeatmapAllToggleBtn from '../../components/buttons/heatmap_all_toggle_btn.vue'
import ShareHeatmapBtn from '../../components/buttons/share_heatmap.vue'
import ShareHeatmapModal from '../../components/modals/share_heatmap.vue'
import RefreshWebDesign from '../../components/refresh_web_design.vue'
import HeatmapMode from '../../components/heatmap_mode.vue'
import InputCopy from '../../components/parts/input_copy.vue'

import AffiliateContractMasterBelow from '../../components/affiliate_contract_master_below.vue'

import HeatmapMultiDisplay from '../../components/heatmap_multi_display.vue';
import HeatmapDesignSelector from '../../components/heatmap_design_selector.vue';
import ScenarioPopupEditor from '../../components/scenario_popup_editor.vue';
import ClickLogsButton from '../../components/click_logs_button.vue';

import HeatmapSimulDisplay from '../../components/heatmap_simul_display.vue';

import DomainOptions from '../../components/domain_options.vue';
import UploadHeatmapImage from '../../components/upload_heatmap_image.vue'
import HelpTooltip from '../../components/parts/help_tooltip.vue'
import HeatmapReportHelp from '../../components/heatmap_report_help.vue'

//library
import Vuelidate from 'vuelidate'
import BootstrapVue from 'bootstrap-vue'
import Sticky from 'vue-sticky-directive'
import Toasted from 'vue-toasted'
import ToggleButton from 'vue-js-toggle-button'
import VueTagsInput from '@johmun/vue-tags-input';
import Pagination from 'vue-pagination-2';

//api
import ActionLogApi from '../../apis/action_log'

//mixins
import TagInputMixin from '../../mixins/tag-input'

const options = {
  position: 'bottom-right',
  fitToScreen: true,
  action: {
    text: 'x 閉じる',
    onClick: function (e, toastObject) {
      toastObject.goAway(0);
    }
  }
}

Vue.use(Vuelidate)
Vue.use(BootstrapVue)
Vue.use(Sticky)
Vue.use(Toasted, options)
Vue.use(ToggleButton)
Vue.component('Pagination', Pagination);
Vue.component('HelpTooltip', HelpTooltip);
Vue.component('HeatmapReportHelp', HeatmapReportHelp);


const app = new Vue({
  el: '#users_vue_app',
  store,
  data() {
    return {
      cv_tag_url: ''
    }
  },
  components: {
    CreativeForm,
    NewCreativeForm,
    WidgetCreativeForm,
    CreativeEditForm,
    CreativePreview,
    OverlayImagePreview,
    PopUpPreview,
    Report,
    NewReport,
    UserFlow,
    Dashboard,
    ScenarioPopupReport,
    CalloutServiceLimit,
    CalloutServiceHostLimit,
    CalloutHostLimit,
    ModalUserHost,
    PlanSelect,
    PlanSelectNew,
    Plans,
    CreateCustomPlan,
    CurrentCustomPlans,
    AddCreditCardModal,
    PushCreditCardModal,
    ChangePlanModal,
    CancelPlanModal,
    ChangeCustomPlanModal,
    ShareHeatmapModal,
    ModalServiceLimit,
    GeneralModal,
    InvoiceStatus,
    AlertInfoLoading,
    ModalWidgetCode,
    ModalWidgetCopy,
    ModalPopUpCopy,
    ModalAreaPopUpCopy,
    ModalScenarioPopupCopy,
    ModalWidgetCopyFree,
    ModalReportCols,
    ModalPopUpCode,
    ModalHeatmapCode,
    ModalAreaPopUpCode,
    ModalOverlayImageCode,
    ModalOverlayImageCopy,
    UrlList,
    ModalUiElementCode,
    PrSetting,
    WidgetLayout,
    SetMainCreditCardButton,
    InputToggleButton,
    RemoveCreditCardButton,
    TogglePreviewDevice,
    WebToolsYoutubeUrl,
    VueTagsInput,
    InitTags,
    ScrollHeatmap,
    ClickHeatmap,
    AttentionHeatmap,
    ResizeHeatmap,
    ResizeHeatmapBtn,
    SynchronizedResizeHeatmap,
    HeatmapMenu,
    HeatmapMenuNew,
    HeatmapSummary,
    HeatmapIframe,
    HeatmapHeader,
    HeatmapEvent,
    HeatmapOsPc,
    HeatmapOsSp,
    CurrentUser,
    ModalPolicyAccept,
    ModalUserInfoAdd,
    NewModalUserInfoAdd,
    ModalServiceNameChange,
    PopupForm,
    EditPopupForm,
    PopupToggleBtn,
    CreativeToggleBtn,
    TagDomainToggleBtn,
    TagDomainPinBtn,
    HeatmapDate,
    CvTagForm,
    HeatmapForm,
    HeatmapHtmlName,
    HeatmapDesignNameNew,
    CheckDomainTag,
    HeatmapToggleBtn,
    HeatmapAllToggleBtn,
    ShareHeatmapBtn,
    RefreshWebDesign,
    HeatmapMode,
    InputCopy,
    AffiliateContractMasterBelow,
    HeatmapMultiDisplay,
    HeatmapDesignSelector,
    ScenarioPopupEditor,
    ClickLogsButton,
    HeatmapSimulDisplay,
    DomainOptions,
    UploadHeatmapImage,
  },
  mixins: [TagInputMixin],
  methods: {
    closeDefaultModal() {
      this.$store.commit("modal/closeDefault")
    },
    openCvTagModal(url) {
      this.cv_tag_url = url
      this.$bvModal.show('modal-cv-tag')
    },
    async openWidgetCodeModal(e, token, url) {
      e.preventDefault()
      this.$store.commit("widget/setToken", token)
      this.$store.commit("widget/setUrl", url)
      this.$bvModal.show('modal-widget-script')
      //ここでAPI
      await ActionLogApi.create({
        type_name: "show_widget_code"
      })
    },
    async openPopUpCodeModal(e, url) {
      e.preventDefault()
      this.$store.commit("pop_up/setUrl", url)
      this.$bvModal.show('modal-pop-up-script')
    },
    async openUiElementCodeModal(e, url, token) {
      e.preventDefault()
      this.$store.commit("ui_element/setToken", token)
      this.$store.commit("ui_element/setUrl", url)
      this.$bvModal.show('modal-ui-element-script')
    },
    async openAreaPopUpCodeModal(e, token, url, setSpecificPositionFlag) {
      e.preventDefault()
      this.$store.commit("area_pop_up/setToken", token)
      this.$store.commit("area_pop_up/setUrl", url)
      this.$store.commit("area_pop_up/setSpecificPositionFlag", setSpecificPositionFlag)
      this.$bvModal.show('modal-area-pop-up-script')
    },
    async openHeatmapCodeModal(e, url) {
      e.preventDefault()
      this.$store.commit("heatmap/setUrl", url)
      this.$bvModal.show('modal-heatmap-script')
    },
    openOverlayImageCodeModal(e, token, url, specific_position_flag) {
      console.log(token, url, specific_position_flag)
      e.preventDefault()
      this.$store.commit("overlay/setToken", token)
      this.$store.commit("overlay/setUrl", url)
      this.$store.commit("overlay/setSpecificPositionFlag", specific_position_flag)
      this.$bvModal.show('modal-overlay-image-script')
    },
    openUrlListModal(e, url_token) {
      e.preventDefault()
      this.$store.commit("pop_up/setToken", url_token)
      this.$bvModal.show('url-list-script')
    },
    openWidgetCopyModal(e, widget_id, widget_name) {
      e.preventDefault()
      this.$bvModal.show('modal-widget-copy')
      this.$store.commit("widget/setId", widget_id)
      this.$store.commit("widget/setName", widget_name + " のコピー")
    },
    openPopUpCopyModal(e, pop_up_id, pop_up_name) {
      e.preventDefault()
      this.$bvModal.show('modal-pop-up-copy')
      this.$store.commit("pop_up/setId", pop_up_id)
      this.$store.commit("pop_up/setName", pop_up_name + " のコピー")
    },
    openAreaPopUpCopyModal(e, area_pop_up_id, area_pop_up_name) {
      e.preventDefault()
      this.$bvModal.show('modal-area-pop-up-copy')
      this.$store.commit("area_pop_up/setId", area_pop_up_id)
      this.$store.commit("area_pop_up/setName", area_pop_up_name + " のコピー")
    },
    openScenarioPopupCopyModal(e, scenario_popup_id, scenario_popup_name) {
      e.preventDefault()
      this.$bvModal.show('modal-scenario-popup-copy')
      this.$store.commit("scenario_popup/setId", scenario_popup_id)
      this.$store.commit("scenario_popup/setName", scenario_popup_name + " のコピー")
    },
    openModalServiceLimit(e) {
      e.preventDefault()
      this.$bvModal.show('modal-service-limit')
    },
    openGeneralModal(e, modalData = null) {
      e.preventDefault();

      // 渡されたmodalDataがない場合、デフォルトのデータを使用
      if (!modalData) {
        modalData = {
          title: 'デフォルトタイトル',
          content: {
            title: '空のモーダルです',
            message: 'モーダルに表示する内容がありません。',
            link: {
              url: '#',
              text: '閉じる',
            },
          },
          class: 'callout-info',
        };
      }

      // ストアにデータを保存
      this.$store.commit('modal/setModalData', modalData);

      // モーダルを表示
      this.$bvModal.show('general-modal');
    },
    openOverlayImageCopyModal(e, overlay_id, overlay_name) {
      console.log(overlay_id, overlay_name)
      e.preventDefault()
      this.$bvModal.show('modal-overlay-image-copy')
      this.$store.commit("overlay/setId", overlay_id)
      this.$store.commit("overlay/setName", overlay_name + " のコピー")
    },
    openPushCardModal(e) {
      e.preventDefault()
      this.$bvModal.show('push-user-credit-card')
    },
    async createCustomPlan(e) {
      e.preventDefault()
      if (this.$store.state.user.is_anual) {
        var interval = "year"
      } else {
        var interval = "month"
      }
      let r = await this.$store.dispatch("custom_plan/create", {
        interval: interval,
        interval_count: this.$store.state.user.interval_count
      })
      //console.log("r", r)
      this.$store.commit("custom_plan/addList", r.data)
      this.$toasted.success('カスタムプランを作成しました。一覧右の「操作」から変更してください。')
      window.scrollTo(0, 0);
    }
  },
  async mounted() {
    await Vue.nextTick()
    if (location.hash == "#heatmap_created") {
      this.$store.commit("heatmap/setUrl", created_heatmap_url)
      this.$bvModal.show('modal-heatmap-script')
    }
    if (location.hash == "#cv_tag_created") {
      this.cv_tag_url = created_cv_tag_url
      this.$bvModal.show('modal-cv-tag')
    }
  },
  watch: {

  },
})
window.users_vue_app = app
